// Import model
import { FilterLeadAppointmentRequest } from '../models/FilterLeadAppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { LeadAppointmentCondition } from '../models/LeadAppointmentCondition';
import { LeadAppointmentFields } from '../models/LeadAppointmentFields';
import { LeadAppointmentIndexedFields } from '../models/LeadAppointmentIndexedFields';

// Import dependency serializers (for complex types)
import { LeadAppointmentConditionSerializer } from './LeadAppointmentConditionSerializer';
import { LeadAppointmentFieldsSerializer } from './LeadAppointmentFieldsSerializer';
import { LeadAppointmentIndexedFieldsSerializer } from './LeadAppointmentIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterLeadAppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterLeadAppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterLeadAppointmentRequest instance
   */
  static deserialize(json: string): FilterLeadAppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterLeadAppointmentRequest instance
   */
  static fromObject(obj: any): FilterLeadAppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterLeadAppointmentRequest');
    }


    const instance: FilterLeadAppointmentRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as LeadAppointmentIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as LeadAppointmentFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        LeadAppointmentConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterLeadAppointmentRequest instances
   */
  static deserializeArray(json: string): FilterLeadAppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterLeadAppointmentRequest instance to a JSON string
   */
  static serialize(instance: FilterLeadAppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterLeadAppointmentRequest instance to a plain object
   */
  static toObject(instance: FilterLeadAppointmentRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        LeadAppointmentConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterLeadAppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: FilterLeadAppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
